import ReconnectingWebSocket from 'reconnecting-websocket';
import { mutate } from 'swr';
import Conversation from 'types/Conversation';
import Message from 'types/Message';
import User from 'types/User';

let rws: ReconnectingWebSocket | undefined;

const init = (jwt: string, user: User) => {
  if (!rws) {
    rws = new ReconnectingWebSocket(
      'wss://jbxvum0iwa.execute-api.eu-west-3.amazonaws.com/staging/',
    );
    rws.addEventListener('open', () => {
      rws!.send(
        JSON.stringify({
          action: 'auth',
          token: jwt,
        }),
      );
    });

    rws.addEventListener('message', (e) => {
      const message: Message = JSON.parse(e.data);

      if (user.UserRole?.some(({ role }) => role === 'MENTOR')) {
        mutate<Conversation>(
          `/messaging/conversation/${message.conversationId}`,
        );
      } else if (user.UserRole?.some(({ role }) => role === 'MENTEE')) {
        mutate<Conversation>('/user/mentee-conversation');
      }
    });
  }
};

const logout = () => {
  if (rws) {
    rws.close();
    rws = undefined;
  }
};

const WebSocketManager = { init, logout };
export default WebSocketManager;
